import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ErrorModel } from 'src/app/core/models/error.model';
import { DominioService } from '../../services/dominio.service';
import { HeadhunterService } from '../../services/headhunter.service';
import { TerritorioService } from '../../services/territorio.service';
import * as _ from 'lodash';
import { HeadhunterFilterModel } from '../../models/headhunter-filter.model';
import { LOCAL_STORAGE, SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';

@Component({
  selector: 'app-dialog-filter',
  templateUrl: './dialog-filter.component.html',
  styleUrls: ['./dialog-filter.component.scss']
})
export class DialogFilterComponent implements OnInit {
  area$: Observable<any>;
  selectedArea: number;

  funcao$: Observable<any>;
  selectedFuncao: number;

  nivel$: Observable<any>;
  selectedNivel: number;

  uf$: Observable<any>;
  selectedUf: number;

  status$: Observable<any>;
  selectedStatus: string;

  formGroup: FormGroup;

  readonly STORAGE_KEY = '_filter_';

  constructor(
      public dialogRef: MatDialogRef<DialogFilterComponent>,
      private territorioService: TerritorioService,
      private dominioService: DominioService,
      private formBuilder: FormBuilder,
      private headhunterService: HeadhunterService,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      @Inject(SESSION_STORAGE) private storageService: StorageService,
      @Inject(LOCAL_STORAGE) private localStorageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      area: [null],
      funcao: [null],
      nivel: ['Junior'],
      uf: [null],
      status: [null],
      filterDetail: [true],
    });

    this.area$ = this.dominioService.getMercados();

    this.funcao$ = this.dominioService.getCargos();

    this.nivel$ = of([
      {
        id: 'Junior',
        name: 'Junior'
      },
      {
        id: 'Pleno',
        name: 'Pleno'
      },
      {
        id: 'Sênior',
        name: 'Sênior'
      },
      {
        id: 'Especialista',
        name: 'Especialista'
      }
    ]);

    this.uf$ = this.territorioService.getAll();

    this.status$ = of([
      {
        id: 'Ativo',
        name: 'Ativo'
      },
      {
        id: 'Inativo',
        name: 'Inativo'
      }
    ]);

    this.activatedRoute.params.subscribe(params => {
      // console.log('CHAMA CONTROLADOR DE FILTRO');
      let hasParams: boolean;

      if (params.after || params.before || params.pageSize) {
        hasParams = Object.keys(params).length > 1;
      }
      else {
        hasParams = Object.keys(params).length > 0;
      }

      // console.log('hasParams', hasParams, params);
      if (hasParams) {
        // console.log('setFilterByQueryString');
        this.setFilterByQueryString(params);
      } else {
        if (this.storageService.has(this.STORAGE_KEY)) {
          const storedValues = this.storageService.get(this.STORAGE_KEY);
          // console.log('LocalStorage', storedValues);
          this.formGroup.patchValue({nivel: ['Junior']});
        }
      }
    });
  }

  aplicarFiltro(): void {
    // console.log(this.formGroup.value);

    this.storageService.set(this.STORAGE_KEY, this.formGroup.value);

    this.headhunterService.getDataByFilter(this.formGroup.value)
        .subscribe(results => {
          this.dialogRef.close(results);
        }, (error: ErrorModel) => {
          console.log(error);
          this.dialogRef.close();
        }).add(() => {
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: (_.pickBy(this.createFiltro()))
          });
    });
  }

  private createFiltro(): HeadhunterFilterModel {
    const multiploFiltro = new HeadhunterFilterModel();
    const values = this.formGroup.value;

    multiploFiltro.area = values.area ? [values.area] : null;
    multiploFiltro.funcao = values.funcao ? [values.funcao] : null;
    multiploFiltro.nivel = values.nivel ? [values.nivel] : null;
    multiploFiltro.status = values.status ? [values.status] : null;
    multiploFiltro.filterDetail = values.filterDetail;

    return multiploFiltro;
  }

  private getValueParam(value): any {
    if (!value) {
      return null;
    }
    return Array.isArray(value) ? value : Array(value);
  }

  private setFilterByQueryString(params: Params): void {
    const filtro = new HeadhunterFilterModel();

    if (params.area) {
      filtro.area = this.getValueParam(params.area);
    }

    if (params.funcao) {
      filtro.funcao = this.getValueParam(params.funcao);
    }

    if (params.nivel) {
      filtro.nivel = this.getValueParam(params.nivel);
    }

    if (params.uf) {
      filtro.uf = this.getValueParam(params.uf);
    }

    if (params.status) {
      filtro.status = this.getValueParam(params.status);
    }

    filtro.filterDetail = true;

    // console.log('filtro', filtro);
    this.formGroup.patchValue(filtro);
  }
}
